export const FIREBASE_ERROR_MAPPING: { [key: string]: string } = {
  "auth/email-already-in-use": "已有其他使用者使用你提供的電子郵件地址。每位使用者都必須擁有專屬電子郵件",
  "auth/email-already-exists": "已有其他使用者使用你提供的電子郵件地址。每位使用者都必須擁有專屬電子郵件",
  "auth/invalid-credential": "驗證失敗",
  "auth/too-many-requests	": "請稍後再嘗試一次",
};
